<template>
  <div class="ma-4">
    <StaffNav />
    <v-row dense>
      <v-col cols="12">
        <v-card>
          <v-card-title style="background-color: #2b3990">
            <span class="headline white--text">{{ titleForm }}</span>
          </v-card-title>
          <v-card-text>
            <v-form ref="form" lazy-validation>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="12" md="6">
                    <v-text-field
                      label="Full Name"
                      v-model="items.name"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="6">
                    <v-text-field
                      label="Address"
                      v-model="items.address"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="6">
                    <v-text-field
                      label="City"
                      v-model="items.city"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="6">
                    <v-text-field
                      label="State"
                      v-model="items.state"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="6">
                    <v-text-field
                      label="Zip"
                      v-model="items.zip"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="6">
                    <v-text-field
                      label="Phone"
                      v-model="items.phone"
                      v-mask="'(###) ###-####'"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="6">
                    <v-text-field
                      label="Email"
                      v-model="items.email"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="6">
                    <v-text-field
                      label="Relationship"
                      v-model="items.relationship"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
              <v-btn
                  fab
                  small
                  @click="showPrintModal()"
                  class="mr-8 mb-2 white--text"
                  color="#2b6993"
                  elevation="4"
                  >
                  <v-icon>print</v-icon>
              </v-btn>
            <v-btn
              class="white--text"
              color="#259647"
              @click="onAddItem"
              v-if="$route.params.action === 'add' && !isAuditorRole"
              >Save</v-btn
            >
            <v-btn
              class="white--text"
              color="#259647"
              @click="onUpdateItem"
              v-if="$route.query.new && !isAuditorRole"
              >Update</v-btn
            >
            <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <Foot />
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import StaffNav from "@/components/StaffNav";
import Foot from "@/components/Footer";
import PrintUtil from "../../../../utils/print-util";

const url = require("../../../client_config/config").url;

const STORE_MODULE = "emergencyContact";

export default {
  components: {
    StaffNav,
    Foot,
  },
  data() {
    return {
      employeeID: this.$route.params.employeeID,
      itemId: "",
      titleForm: "New Garnishment",
      items: {},
      routeName: "EmergencyContact",
      token: localStorage.getItem('token'),
    };
  },
  computed: {
    ...mapState(STORE_MODULE, ["isLoading", "item"]),
    staffName() {
      return this.$store.state.users.user.Name;
    },
    isAuditorRole() {
      return localStorage.getItem("userRole") === 'Auditor'
    },
    generateDownloadUrl() {
      return `${url}/emergencyContact/print/${this.itemId}`;
    },
  },

  created() {
    if (this.$route.query.new) {
      this.fetch();
    }
  },
  async mounted() {
      window.addEventListener('keydown', async (event) => {
          PrintUtil.handleKeydown(event, this.generateDownloadUrl, this.itemId, this.token, 'EmergencyContact');
      });
  },

  beforeDestroy() {
      window.removeEventListener('keydown', (event) => {
          PrintUtil.handleKeydown(event, this.generateDownloadUrl, this.itemId, this.token, 'EmergencyContact');
      });
  },

  methods: {
    ...mapActions(STORE_MODULE, ["getItem", "addItem", "updateItem"]),

    async fetch() {
      await this.getItem(this.$route.query.id);
      this.viewItem(this.item);
    },

    viewItem(item) {
      this.titleForm = "Viewing Emergency Contact";
      this.itemId = item._id;

      this.items.name = item.Name;
      this.items.address = item.Address;
      this.items.city = item.City;
      this.items.state = item.State;
      this.items.zip = item.Zip;
      this.items.phone = item.Phone;
      this.items.email = item.Email;
      this.items.relationship = item.Relationship;
    },

    async onUpdateItem() {
      try {
        const data = {
          Name: this.items.name,
          Address: this.items.address,
          City: this.items.city,
          State: this.items.state,
          Zip: this.items.zip,
          Phone: this.items.phone,
          Email: this.items.email,
          Relationship: this.items.relationship,
        };

        const result = await this.updateItem({
          id: this.itemId,
          data,
        });

        if (result.status === 200) {
          this.$router.push({
            path: `/${this.routeName}/${this.employeeID}`,
          });
        }
      } catch (error) {
        this.errorMsg("updating", "record", error);
      }
    },

    async onAddItem() {
      try {
        const data = {
          Name: this.items.name,
          Address: this.items.address,
          City: this.items.city,
          State: this.items.state,
          Zip: this.items.zip,
          Phone: this.items.phone,
          Email: this.items.email,
          Relationship: this.items.relationship,
          StaffID: this.employeeID,
        };

        const response = await this.addItem(data);

        if (response.status === 201) {
          this.$router.push({
            path: `/${this.routeName}/${this.employeeID}`,
          });

          this.itemId = response.data.results._id;
        }
      } catch (error) {
        this.errorMsg("adding", "record", error);
      }
    },

    close() {
      this.$router.push({
        path: `/${this.routeName}/${this.employeeID}`,
      });
    },

    errorMsg(action, item, error) {
      console.error(`An error occured whiling ${action} ${item}`, error);
    },
    async showPrintModal() {
        PrintUtil.showPrintOption(this.generateDownloadUrl, this.itemId, this.token,'EmergencyContact');
    },
  },
};
</script>
